import React from "react";

let Universe = props => (
  <svg width={27} height={27} viewBox="0 0 27 27" {...props}>
    <title>{"Universe_icon"}</title>
    <path d="M13.25 16a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5zm0-1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm4.248-8.324c-.488.25-.917.599-1.262 1.019a6.75 6.75 0 1 0 3.75 6.486 3.976 3.976 0 0 0 1.513-.587l.001.156a8.25 8.25 0 1 1-4.002-7.074zm1.828 6.059a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM1.322 7.473c.318.42.716.775 1.171 1.042A11.71 11.71 0 0 0 1.5 13.25C1.5 19.74 6.76 25 13.25 25S25 19.74 25 13.25 19.74 1.5 13.25 1.5a11.7 11.7 0 0 0-5.421 1.323A4.022 4.022 0 0 0 6.715 1.72 13.19 13.19 0 0 1 13.25 0C20.568 0 26.5 5.932 26.5 13.25S20.568 26.5 13.25 26.5 0 20.568 0 13.25c0-2.07.475-4.03 1.322-5.777zm3.192.09a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
  </svg>
);

export default Universe;
